export default __webpack_public_path__ + "static/image-066ce43cce88c8d07b8a625a15a8fbb6.png";